import React, { ReactElement, useEffect } from "react";
import { uniqueId } from "lodash";
import { ReactComponent as PlusButton } from "assets/plus-button.svg";
import "./index.less";
import { Button } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { rootReducerType } from "redux/combineReducers";
import { decodeJWT } from "common/functions";
import i18n from "internationalization/i18n";
import { emailToUsername } from "common/utils";
import Notification from "../NotificationMessage/Notification";
import { useSaveAnalysisMutation } from "services/analysisService";
import InfoCard from '../../../pages/analysis/components/InfoCard/InfoCard';
import { useNavigate } from 'react-router-dom';

type Props = {
  activeStats?: string[];
  inactiveStats?: string[];
  expanded?: boolean;
  setExpanded: React.Dispatch<React.SetStateAction<boolean>>
  setInactiveStats: React.Dispatch<React.SetStateAction<string[] | undefined>>
  setActiveStats: React.Dispatch<React.SetStateAction<string[] | undefined>>
  // setShouldRefresh: React.Dispatch<React.SetStateAction<string[] | undefined>>
  shouldRefresh?: boolean
};

const CustomiseAnalysis: React.FC<Props> = ({ activeStats, inactiveStats, setInactiveStats, setActiveStats, expanded, setExpanded, shouldRefresh }): ReactElement => {

  const [saveAnalysis, { isSuccess, data:SaveData }] = useSaveAnalysisMutation();

  const navigate = useNavigate()

  const { isLoggedIn } = useSelector(
    (state: rootReducerType) => state.authenticationReducer
  );

  const { shouldRefresh:shouldRefreshs } = useSelector(
    (state: rootReducerType) => state.anaChartReducer
  );

  const params = {
    userName: emailToUsername(decodeJWT(isLoggedIn).email),
    activeStats: activeStats,
    inactiveStats: inactiveStats
  };

  const dispatch = useDispatch();

  useEffect(() => {
    if (isSuccess) {
      Notification({ type: "success", message: i18n.t("analysis.toastTitle"), description: SaveData && SaveData.message as any });
      if (setExpanded) setExpanded(!expanded);
      dispatch({ type: 'setShouldRefresh', payload: !shouldRefreshs });
      // navigate('/analysis', { replace: true });
    }
  }, [isSuccess]);

  const addStat = (index: number) => {
    if (inactiveStats)
      setInactiveStats(inactiveStats.filter((_, i) => i != index));
    if (activeStats && inactiveStats)
      setActiveStats([...activeStats, inactiveStats[index]]);
  };

  return (
    <section className="expanded-main-section">
      <div className="expanded-header">
        <h1>{i18n.t("Customise")}</h1>
        <Button
          size="small"
          onClick={() => {
            saveAnalysis(params as any);
          }}>{i18n.t("Save")}</Button>
      </div>
      <section className="expanded-inactive-stats">
        {inactiveStats && inactiveStats.map((stat, index) => {
          if (stat)
            return (
              <div className="summary-card-container" key={uniqueId()}>
                <div className="action-image" onClick={() => addStat(index)}>
                  <PlusButton fill="white" />
                </div>
                <InfoCard
                  description={stat}
                  simpleCard={true}
                />
              </div>
            );
          else return null;
        })}
      </section>
    </section>
  );
};

export default CustomiseAnalysis;
